// extracted by mini-css-extract-plugin
export default {"iframeContent":"LUUgaZqCKuK4nOnMVkGg"};